<div class="wrap">
  <h3>{{data.actionDialog === "new"? "Ajouter un élément": "Modifier l'élément" }}</h3>
  <form [formGroup]="choiceForm" (ngSubmit)="onSubmit(this.choiceForm.get('choice').value)">
    <mat-form-field appearance="outline">
      <mat-label>Selectionnez votre choix</mat-label>
      <mat-select formControlName="choice" (selectionChange)="resetForm()">
        <mat-option value="Trophy">Trophée</mat-option>
        <mat-option value="Image">Image</mat-option>
        <mat-option value="Url">Lien</mat-option>
      </mat-select>

    </mat-form-field>

    <ng-container [ngSwitch]="choiceForm.get('choice').value">
      <ng-container *ngSwitchCase="'Trophy'">
        <p *ngIf="!myProgression?.length" [style.margin-bottom.px]="25">Aucun trophée disponible</p>
        <mat-form-field appearance="outline" *ngIf="myProgression?.length">
          <mat-label>Selectionnez un trophée</mat-label>
          <mat-select formControlName="trophy">
            <mat-optgroup [color]="color" *ngFor="let p of myProgression" [label]="p?.support.supportName">
              <ng-container *ngFor="let l of p?.niveaux">
                <mat-option *ngIf="l?.validation?.dateValidation" [value]="[p.support.supportId,  l.niveauId]">
                  {{l?.nom}} -
                  {{l?.description}}</mat-option>
              </ng-container>
            </mat-optgroup>

          </mat-select>
        </mat-form-field>
      </ng-container>

      <ng-container *ngSwitchCase="'Image'">
        <div class="label-file">
          <p> Choisir une image </p>
          <input matinput type="file" class="input-file" formControlName="imgFile"
            (change)="convertFile($event, 'imgLink')">
        </div>
      </ng-container>

      <mat-form-field appearance="outline" *ngSwitchCase="'Image'">
        <mat-label>Lien de l'image</mat-label>
        <input matInput formControlName='imgLink' (input)="convertFile(choiceForm.get('imgLink').value , 'imgFile')">
      </mat-form-field>

      <mat-form-field appearance="outline" *ngSwitchCase="'Image'">
        <mat-label>Ajouter un lien URL à l'image</mat-label>
        <input matInput input="text" formControlName="link">
      </mat-form-field>

      <ng-container *ngSwitchCase="'Image'">
        <img [src]=" imageBase64" *ngIf="data.newTrophy.imageUrl || imageBase64">
      </ng-container>

      <!-- <ng-container *ngSwitchCase="'Image'">
        <p *ngIf="imageBase64 === null || imageBase64 === undefined">Cette image n'est pas disponible</p>
      </ng-container> -->

      <mat-form-field appearance="outline" *ngSwitchCase="'Url'">
        <mat-label>Lien externe</mat-label>
        <input matInput type="text" formControlName="externLink">
      </mat-form-field>

    </ng-container>
    <div class="btn_action">
      <button type="button" class="back" (click)="dialog.closeAll()">Annuler</button>
      <ng-container [ngSwitch]="choiceForm.get('choice').value">

        <button *ngSwitchCase="'Trophy'" type="submit" class="confirm" [mat-dialog-close]="data.newTrophy"
          [style.opacity]="!choiceForm.get('trophy').value ? 0.5 : 1"
          [disabled]="!myProgression?.length || !choiceForm.get('trophy').value ">Confirmer</button>

        <button *ngSwitchCase="'Image'" type="submit" class="confirm" [mat-dialog-close]="data.newTrophy"
          [style.opacity]="!choiceForm.get('imgFile').value && !choiceForm.get('imgLink').value && !imageBase64 && !choiceForm.get('link').value ? 0.5 : 1"
          [disabled]="  !choiceForm.get('imgFile').value && !choiceForm.get('imgLink').value && !imageBase64  && !choiceForm.get('link').value">Confirmer</button>

        <button *ngSwitchCase="'Url'" type="submit" class="confirm" [mat-dialog-close]="data.newTrophy"
          [style.opacity]="!choiceForm.get('externLink').value ? 0.5 : 1"
          [disabled]=" !choiceForm.get('externLink').value  ">Confirmer</button>

        <button *ngSwitchDefault type="submit" class="confirm" [style.opacity]="0.5">Confirmer</button>

      </ng-container>
    </div>



  </form>
</div>